interface TextAreaInputProps {
  Name?: string;
  Placeholder?: string;
  Value?: string;
  Capitalize?: boolean;
  onChange?: (value: string) => void;
}

export default function TextAreaInput({
  Name = "input name",
  Placeholder = "enter the name",
  Value = "",
  Capitalize = true,
  onChange = () => {},
}: TextAreaInputProps) {
  return (
    <div className="space-y-2">
      <p className="capitalize font-primary">{Name}</p>
      <textarea
        className={`w-full outline-none border p-2 rounded ${Capitalize && "capitalize"} px-4 h-[150px]`}
        placeholder={Placeholder}
        value={Value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
